<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="报名信息"
    width="50%"
    :before-close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="130px"
      style="height: 500px; overflow: auto"
    >
      <!-- <el-form-item label="课程名称">
        <span></span>
      </el-form-item>
      <el-form-item label="课程所属专业">
        <span></span>
      </el-form-item> -->
      <el-form-item label="姓名：">
        <span>{{ form.name }}</span>
      </el-form-item>
      <el-form-item label="准考证号：">
        <span>{{ form.examNumber }}</span>
      </el-form-item>
      <el-form-item label="身份证号：">
        <span>{{ form.idCard }}</span>
      </el-form-item>
      <el-form-item label="手机号：">
        <span>{{ form.phone }}</span>
      </el-form-item>
      <el-form-item label="微信号：">
        <span>{{ form.wechat }}</span>
      </el-form-item>
      <el-form-item label="邮箱：">
        <span>{{ form.email }}</span>
      </el-form-item>
      <el-form-item label="考生来源：">
        <span v-if="form.stuSource == '1'">社会生</span>
        <span v-if="form.stuSource == '2'">助学机构</span>
        <span v-if="form.stuSource == '3'">公开学院,高职相沟通,本科二学历</span>
      </el-form-item>
      <el-form-item label="层次：">
        <span v-if="form.level == '1'">本科</span>
        <span v-if="form.level == '2'">专科</span>
      </el-form-item>
      <el-form-item label="是否申请学士学位：">
        <span v-if="form.degreeStatus == '1'">是</span>
        <span v-if="form.degreeStatus == '2'">否</span>
      </el-form-item>
      <!-- <el-form-item label="学生简表">
        <span></span>
      </el-form-item> -->
      <!-- <el-form-item label="本人所在专业">
        <span>222</span>
      </el-form-item>
      <el-form-item label="审核提示">
        <span>222</span>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-radio-group v-model="radio">
          <el-radio :label="3">待审核</el-radio>
          <el-radio :label="6">审核通过</el-radio>
          <el-radio :label="9">审核退回</el-radio>
          <el-radio :label="12">审核未通过</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
  </el-dialog>
</template>

<script>
import * as api from '@/api/ClassRegistManagement/index.js'

export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  data() {
    return {
      dialogVisible: true,
      status: '',
      form: {},
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeRegistInfo')
    },
    async getRegistUserInfo() {
      const { code, data } = (
        await api.getRegistUserInfo({
          courseId: this.params.row.albumId,
          uid: this.params.row.uid,
          type: this.params.row.infoType,
        })
      ).data
      if (code === 100000) {
        this.form = data
      }
    },
  },
  watch: {
    params: {
      immediate: true,
      handler: function (value) {
        console.log(66, this.params)
        if (value && value.status) {
          this.status = value.status
          this.getRegistUserInfo()
        }
      },
    },
  },
}
</script>